import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

import { postApi, putApi } from "../../../../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
} from "../../../../../utils/toastify-message/ToastifyMessage";
import DocumentFileInput from "../../../../common/inputs/DocumentFileInput";

const Ducuments = ({ data, allData, reGetData }) => {
  const [files, setFiles] = useState({
    frontNationalIdImage: null,
    backNationalIdImage: null,
    threeMonthBankStatementImage: null,
    salarySlipImage: null,
    birthCertificateImage: null,
  });

  const [uploadedData, setUploadedData] = useState({
    frontNationalIdImage: "",
    backNationalIdImage: "",
    threeMonthBankStatementImage: "",
    salarySlipImage: "",
    birthCertificateImage: "",
  });

  useEffect(() => {
    if (data) {
      setUploadedData({
        frontNationalIdImage: data?.frontNationalIdImage || "",
        backNationalIdImage: data?.backNationalIdImage || "",
        threeMonthBankStatementImage: data?.threeMonthBankStatementImage || "",
        salarySlipImage: data?.salarySlipImage || "",
        birthCertificateImage: data?.birthCertificateImage || "",
      });
    }
  }, [data]);

  const faDocText = {
    frontNationalIdImage: "تصویر جلوی کارت ملی",
    backNationalIdImage: "تصویر پشت کارت ملی",
    threeMonthBankStatementImage: "گزارش 3 ماهه حساب",
    salarySlipImage: "فیش حقوقی",
    birthCertificateImage: "شناسنامه",
  };

  const handleFileChange = (e) => {
    const { name, files: selectedFiles } = e.target;
    const file = selectedFiles[0];
    const maxFileSize = 2 * 1024 * 1024; // 2MB
    const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

    if (file && file.size > maxFileSize) {
      errorMessage("فایل انتخابی نباید بیشتر از 2 مگابایت باشد.");
      return;
    }

    if (file && !allowedTypes.includes(file.type)) {
      errorMessage("فایل انتخابی باید فرمت jpg، png یا pdf داشته باشد.");
      return;
    }
    setFiles((prevFiles) => ({
      ...prevFiles,
      [name]: file,
    }));
    uploadFile(name, file);
  };

  const editForm = async ({ fileData, name }) => {
    const body = { ...fileData, nationalId: data?.nationalId };
    const path = `admin/loans/${allData?._id}/loanGuarantors`;
    try {
      await putApi({ path, body });
      successMessage(` ${faDocText?.[name]} با موفقیت آپلود شد.`);
    } catch (error) {
      console.log(error);
    }
  };

  const uploadFile = async (name, file) => {
    const formData = new FormData();
    formData.append("file", file);
    try {
      const path = "filemanagers";
      const response = await postApi({
        path,
        body: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      const fileData = { [name]: response?.data?.data?.data };
      setUploadedData({
        ...uploadedData,
        ...fileData,
      });
      editForm({
        fileData,
        name,
      });
    } catch (error) {
      console.error("خطا در آپلود فایل:", error);
    }
  };

  const deleteFile = async (name) => {
    const body = { [name]: "", nationalId: data?.nationalId };
    const path = `admin/loans/${allData?._id}/loanGuarantors`;
    try {
      await putApi({ path, body });
      successMessage(` ${faDocText?.[name]} با موفقیت حذف شد.`);
      setUploadedData({ ...uploadedData, [name]: "" });
      reGetData();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.5,
        // ease: [0, 0.71, 0.2, 1.01]
      }}
      className="w-11/12 mx-auto  border border-gray-200 rounded-lg my-6 bg-white dark:bg-[#060d26] shadow-sm p-6"
    >
      <h3 class="mb-4 text-lg font-medium leading-none text-gray-900 dark:text-white">
        مدارک
      </h3>
      <div className="grid gap-6 mb-6 md:grid-cols-2">
        <DocumentFileInput
          name="frontNationalIdImage"
          label={"تصویر جلو کارت ملی"}
          handleFileChange={handleFileChange}
          uploadedData={uploadedData}
          deleteFile={deleteFile}
        />
        <DocumentFileInput
          name="backNationalIdImage"
          label={"تصویر پشت کارت ملی"}
          handleFileChange={handleFileChange}
          uploadedData={uploadedData}
          deleteFile={deleteFile}
        />
        <DocumentFileInput
          name="birthCertificateImage"
          label={"تصویر شناسنامه"}
          handleFileChange={handleFileChange}
          uploadedData={uploadedData}
          deleteFile={deleteFile}
        />
        <DocumentFileInput
          name="salarySlipImage"
          label={"فیش حقوقی"}
          handleFileChange={handleFileChange}
          uploadedData={uploadedData}
          deleteFile={deleteFile}
        />
        <DocumentFileInput
          name="threeMonthBankStatementImage"
          label={"پرینت حساب 3 ماهه"}
          handleFileChange={handleFileChange}
          uploadedData={uploadedData}
          deleteFile={deleteFile}
        />
      </div>
    </motion.div>
  );
};

export default Ducuments;
